import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import ProtectedRoute from "./Components/ProtectedRoute";
import AdminRoute from "./Components/AdminRoute";
import AppLayout from "./Components/AppLayout";
import LoginScreen from "./Components/LoginScreen";
import MainScreen from "./Components/MainScreen";
import ResultFilterScreen from "./Components/ResultFilterScreen";
import Alerts from "./Components/Alerts";
import ScheduledSearchDetails from "./Components/ScheduledSearchDetails.js";
import ScheduledSearches from "./Components/ScheduledSearches.js";
import AlertDetails from "./Components/AlertDetails.js";
import ScheduledSearchCreate from "./Components/ScheduledSearchCreate.js";
import AlertCreate from "./Components/AlertCreate.js";
import AdminOverview from "./Components/admin/AdminOverview.js";
import AdminJobRuns from "./Components/admin/AdminJobRuns.js";
import AdminAlertFirings from "./Components/admin/AdminAlertFirings.js";
import AdminWorkerErrors from "./Components/admin/AdminWorkerErrors.js";
import AdminManualTriggers from "./Components/admin/AdminManualTriggers.js";
import AdminEmailLog from "./Components/admin/AdminEmailLog.js";
import AdminScrapflyDetails from "./Components/admin/AdminScrapflyDetails.js";
import Briefings from "./Components/Briefings.js";
import BriefingCreate from "./Components/BriefingCreate.js";
import BriefingDetails from "./Components/BriefingDetails.js";
import AdminBriefings from "./Components/admin/AdminBriefings.js";
import AdminSmartAlerts from "./Components/admin/AdminSmartAlerts.js";
import AdminUsers from "./Components/admin/AdminUsers.js";
import AdminUserCreate from "./Components/admin/AdminUserCreate.js";
import AdminUserDetails from "./Components/admin/AdminUserDetails.js";
import SmartAlerts from "./Components/SmartAlerts.js";
import SmartAlertCreate from "./Components/SmartAlertCreate.js";
import SmartAlertDetails from "./Components/SmartAlertDetails.js";
import SmartAlertRunDetail from "./Components/SmartAlertRunDetail.js";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/main" element={<MainScreen />} />
              <Route path="/resultFilter" element={<ResultFilterScreen />} />
              <Route path="/alarms" element={<Alerts />} />
              <Route path="/alarmDetails" element={<AlertDetails />} />
              <Route path="/alertCreate" element={<AlertCreate />} />
              <Route path="/scheduledSearches" element={<ScheduledSearches />} />
              <Route path="/scheduled-search-details/:id" element={<ScheduledSearchDetails />} />
              <Route path="/scheduledSearchCreate" element={<ScheduledSearchCreate />} />
              <Route path="/briefings" element={<Briefings />} />
              <Route path="/briefingCreate" element={<BriefingCreate />} />
              <Route path="/briefing-details/:id" element={<BriefingDetails />} />
              <Route path="/smartAlerts" element={<SmartAlerts />} />
              <Route path="/smartAlertCreate" element={<SmartAlertCreate />} />
              <Route path="/smart-alert-details/:id" element={<SmartAlertDetails />} />
              <Route path="/smart-alert-run/:runId" element={<SmartAlertRunDetail />} />
              <Route path="/admin" element={<AdminRoute><AdminOverview /></AdminRoute>} />
              <Route path="/admin/jobs" element={<AdminRoute><AdminJobRuns /></AdminRoute>} />
              <Route path="/admin/alert-firings" element={<AdminRoute><AdminAlertFirings /></AdminRoute>} />
              <Route path="/admin/errors" element={<AdminRoute><AdminWorkerErrors /></AdminRoute>} />
              <Route path="/admin/triggers" element={<AdminRoute><AdminManualTriggers /></AdminRoute>} />
              <Route path="/admin/emails" element={<AdminRoute><AdminEmailLog /></AdminRoute>} />
              <Route path="/admin/scrapfly" element={<AdminRoute><AdminScrapflyDetails /></AdminRoute>} />
              <Route path="/admin/briefings" element={<AdminRoute><AdminBriefings /></AdminRoute>} />
              <Route path="/admin/smart-alerts" element={<AdminRoute><AdminSmartAlerts /></AdminRoute>} />
              <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
              <Route path="/admin/users/create" element={<AdminRoute><AdminUserCreate /></AdminRoute>} />
              <Route path="/admin/users/:id" element={<AdminRoute><AdminUserDetails /></AdminRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </NotificationProvider>
    </QueryClientProvider>
  );
};

export default App;
